module.exports = __webpack_public_path__ + "img/data-center.3e84a514.gif";